"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _chunkRIUJJBZNjs = require('../chunk-RIUJJBZN.js');require('../chunk-262UWVGV.js');var _react = require('@emotion/react');var _jsxruntime = require('react/jsx-runtime');function a(){let e=_chunkRIUJJBZNjs.b.call(void 0, );return _jsxruntime.jsx.call(void 0, _react.Global,{styles:_react.css`
        .h1_variant {
          font-size: 48px;
          font-weight: 700;
          line-height: 56px;
          letter-spacing: -0.01em;

          @media screen and (max-width: ${e.mobile}) {
            font-size: 32px;
            line-height: 40px;
          }
        }

        .h2_variant {
          font-size: 32px;
          font-weight: 700;
          line-height: 40px;
          letter-spacing: -0.01em;

          @media screen and (max-width: ${e.mobile}) {
            font-size: 24px;
            line-height: 32px;
            letter-spacing: -0.005em;
          }
        }

        .h3_variant {
          font-size: 24px;
          font-weight: 700;
          line-height: 32px;
          letter-spacing: -0.005em;

          @media screen and (max-width: ${e.mobile}) {
            font-size: 20px;
            line-height: 26px;
          }
        }

        .h4_variant {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          letter-spacing: -0.005em;
        }

        .h5_variant {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: -0.005em;
        }

        .h6_variant {
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: 0em;
        }

        .p1_variant {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
        }

        .p2_variant {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
        }

        .p3_variant {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
        }
      `})}var l=a;exports.Global = a; exports.default = l;
